<div class="confirm-dialog-container" [class.warning]="dialogType === 'warning'" [class.danger]="dialogType === 'danger'" [class.info]="dialogType === 'info'">
  <h2 mat-dialog-title class="dialog-title-container">
    <div class="icon-badge">
      <mat-icon class="status-icon">{{ iconName }}</mat-icon>
    </div>
    <span class="title-text">{{ heading }}</span>
  </h2>
  
  <mat-dialog-content class="dialog-body">
    <p class="dialog-message">
      {{ message }}
    </p>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" class="dialog-footer">
    <button 
      mat-stroked-button 
      class="btn-cancel"
      mat-dialog-close 
      tabindex="-1"
    >
      {{ cancelButtonText }}
    </button>
    <button
      mat-flat-button
      class="btn-confirm"
      (click)="handleClose()"
      tabindex="1"
    >
      {{ confirmButtonText }}
    </button>
  </mat-dialog-actions>
</div>
